import { Stack } from '@lingoda/ui';
import type { ContentBlock } from '@lingoda/monolith-graphql';
import InformationBanner from './InformationBanner';

interface Props {
    informationContentBlocks: ContentBlock[];
}

const CheckoutContentBlocks = ({ informationContentBlocks }: Props) => (
    <Stack spacing={1}>
        {informationContentBlocks.map((contentBlock, index) => (
            <InformationBanner key={index} contentBlock={contentBlock} />
        ))}
    </Stack>
);

export default CheckoutContentBlocks;
